module.exports = __webpack_public_path__ + "img/652.88fc30c4.png";